<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: zouyuping
 * @LastEditTime: 
 * @FilePath: 
 * @Description:商品详情中图文简介组件
-->
<template>
  <van-tabs
    v-if="list.length > 0"
    v-model="active"
    scrollspy
    sticky
    :color="$store.state.tc"
  >
    <van-tab v-for="index in list" :title="index" :key="index">
      <div class="tab_item_con">
        <div v-if="index == '简介'" class="tab_info_con">
          <p class="c-main-txt font-30 bold-600">商品简介</p>
          <p class="c-main-txt">BRIEF INTRODUCTION</p>
          <p class="m-tb-20">{{ textInduction }}</p>
        </div>
        <div v-else>
          <p class="c-main-txt font-30 bold-600">商品图文</p>
          <p class="c-main-txt">PICTURE TEXT</p>
          <ul class="tab_imgs_con">
            <li v-for="(imgItem, imgIndex) in imgInfo" :key="imgIndex">
              <img :src="imgItem.imgUrl" alt="" />
            </li>
          </ul>
        </div>
      </div>
    </van-tab>
  </van-tabs>
</template>

<script>
export default {
  name: "GoodsImgCom",
  props: {
    textInduction: {
      type: String,
      default: "",
    },
    imgInfo: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      list: ["简介", "图文"],
      // list: [],
      active: 0,
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.tab_item_con {
  padding: 30px;
  .tab_imgs_con {
    margin-top: 20px;
    li {
      img {
        width: 100%;
        vertical-align: middle;
      }
    }
  }
}
</style>
